import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { BornAggregazioneSearchCrumbs } from 'subscription/constants/breadcrumb';
import ActionsList from './actions';
import PersonSearch from 'shell/components/shared/person-search';

const BornAggregazioneSearch = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={BornAggregazioneSearchCrumbs} />
      <PersonSearch
        pathname="/iscrizioni/aire-nascita-aggregazione/trascrizione"
        action={ActionsList}
        addedTitle="- Iscrizione AIRE atto di nascita - Aggregazione"
        isAire
      />
    </Fragment>
  );
};

BornAggregazioneSearch.displayName = 'Born Aggregazione Search page component';

export default BornAggregazioneSearch;
